<template>
    <div>
        <PageTitle title="Packs de eventos"/>
        <FirstBanner/>

        <div class="container mt-2">
            <SearchEvents
                :placeholder="$t('teatros.buscar_placeholder')"
                :teatro="configuracion.hash_teatro"
            />
        </div>

        <ContentOrLoading>
            <template v-if="packs">
                <ListadoPacks :packs="packs" v-if="packs.data.length > 0"/>
                <NoEvents v-else/>
            </template>
        </ContentOrLoading>        
    </div>
</template>
  
<script>
    import PageTitle from '@/components/frontend/shared/PageTitle'
    import FirstBanner from '@/components/frontend/shared/FirstBanner'
    import SearchEvents from '@/components/frontend/events/SearchEvents'
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import NoEvents from '@/components/frontend/events/listado/NoEvents';
    import ListadoPacks from '../../../components/frontend/packs/ListadoPacks.vue';

    export default {
        head: {
            title: function() {
                return {
                    inner: "Packs de ventos",
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title,
                };
            },
            meta: function() {
                return [
                    {
                        name: "application-name",
                        content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + " - Venta Oficial de entradas",
                    },
                    {
                        name: "description",
                        content: this.teatro.meta_description ? this.teatro.meta_description : "Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada",
                        id: "desc",
                    },
                ];
            },
        },
        data() {
            return {
                packs: null
            }
        },
        created() {
            this.getPacks();
        },
        methods: {
            getPacks() {
                const params = {                    
                    filters: {
                        tid : this.configuracion.hash_teatro
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias("front.packs.index"), params).then(res => {
                    this.packs = res.data;
                });
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        components: {
            PageTitle, FirstBanner, SearchEvents, ContentOrLoading, NoEvents, ListadoPacks
        }
    };
</script>
  